import React, { Component, Fragment } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import TransactionItem from './TransactionItem';
import i18n from '../../../../i18n/i18n.js';

type Props = {
    language: string,
    purchaseHistory: {
        collection: Array,
        total: number,
        page: number,
    },
    lng: string,
    fetchPurchaseHistory: Function,
};

type State = {
    content: Array,
    status: String,
    page: number,
    hasMore: boolean,
};

export default class TransactionsHistory extends Component<Props, State> {
    state = {
        content: [],
        status: 'active',
        page: 1,
        hasMore: true,
    };

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        this.setState({
            content: nextProps.purchaseHistory.collection.map(item => 0),
        });
    }

    handleContentClick = index => {
        let sliced = this.state.content.slice();
        sliced[index] = 1 - this.state.content[index];

        this.setState({
            content: sliced,
        });
    };

    fetchMoreHistory = () => {
        this.props.fetchPurchaseHistory(this.state.status, this.state.page);
        this.setState({
            page: this.state.page + 1,
        });
    };

    handleStatusChange = e => {
        this.setState({ status: e.target.value, hasMore: true, page: 1 });
        this.props.fetchPurchaseHistory(e.target.value, 0);
    };

    fetchMoreData = () => {
        const { purchaseHistory } = this.props;
        if (
            purchaseHistory.page !== 0 &&
            purchaseHistory.collection.length === purchaseHistory.total
        ) {
            this.setState({ hasMore: false });
            return;
        }

        // a fake async api call like which sends
        // 20 more records in .5 secs
        setTimeout(() => {
            this.fetchMoreHistory();
        }, 500);
    };

    render() {
        let lng = this.props.lng;
        const items = this.props.purchaseHistory.collection;

        const transactions = items.map((item, index) => {
            return (
                <TransactionItem
                    key={index}
                    handleContentClick={this.handleContentClick}
                    content={this.state.content}
                    item={item}
                    index={index}
                    status={this.state.status}
                    lng={lng}
                    subscriptionsData={false}
                />
            );
        });

        return (
            <div className="transactionrows">
                <h4>{i18n.t('purchase_history', { lng })}:</h4>
                <div className="type">
                    <i className="ipic_arrow-d" />
                    <select
                        value={this.state.status}
                        onChange={this.handleStatusChange}
                    >
                        <option value="all">{i18n.t('all', { lng })}</option>
                        <option value="active">
                            {i18n.t('active', { lng })}
                        </option>
                        <option value="inactive">
                            {i18n.t('inactive', { lng })}
                        </option>
                    </select>
                </div>
                {items.length !== 0 ? (
                    <InfiniteScroll
                        dataLength={items.length}
                        next={this.fetchMoreData}
                        hasMore={this.state.hasMore}
                        loader={
                            this.props.purchaseHistory.total > 5 &&
                            items.length !==
                                this.props.purchaseHistory.total && (
                                <h4>Loading...</h4>
                            )
                        }
                        height={190}
                        endMessage={
                            this.props.purchaseHistory.total > 5 &&
                            items.length ===
                                this.props.purchaseHistory.total && (
                                <p>
                                    <b>
                                        {this.state.status === 'active'
                                            ? i18n.t(
                                                  'no_more_active_accesses',
                                                  { lng }
                                              )
                                            : i18n.t(
                                                  'no_more_inactive_accesses',
                                                  { lng }
                                              )}
                                    </b>
                                </p>
                            )
                        }
                    >
                        {' '}
                        <div className="acc-container">
                            <div className="headrow">
                                <span>{i18n.t('name', { lng })}</span>
                                <span
                                    style={{
                                        float: 'right',
                                        paddingRight: '20%',
                                    }}
                                >
                                    status
                                </span>
                            </div>
                            {transactions}
                        </div>
                    </InfiniteScroll>
                ) : (
                    <span style={{ fontStyle: 'italic' }}>
                        {this.state.status === 'active'
                            ? i18n.t('no_available_active_accesses', { lng })
                            : i18n.t('no_available_inactive_accesses', { lng })}
                    </span>
                )}
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        language: state.auth.language,
    };
};



// WEBPACK FOOTER //
// ./src/ui/components/Forms/History/index.js